/**
 * Parses a specific cookie value from a cookie string.
 * @param cookie - The full cookie string
 * @param id - The cookie name to extract
 * @returns The cookie value or empty string if not found
 */
export const parseCookie = (cookie: string, id: string): string => {
  if (!cookie) {
    return ''
  }

  const value = `; ${cookie}`
  const parts = value.split(`; ${id}=`)

  if (parts.length === 2) {
    const value = parts?.at(1)?.split(';')?.at(0)
    return value ?? ''
  }
  return ''
}
